import { configureStore } from "@reduxjs/toolkit";
import auth from "./auth/reducer";
import user from "./user/reducer";
import study from "./study/reducer";
import files from "./files/reducer";

export default configureStore({
  reducer: { auth, user, study, files },
});
